define('modules/Checkout/Terms',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var addressType = 'terms-billing';
    var defaultBillingAddress = {};
    var viewModel = {};
    var forms = {
        selectedBillingAddress: {
            Fields: [{
                "Name": 'Billing address Id',
                "Field": '#terms-billing-hdAddressId',
                "Param": 'billingAddressId',
                "Type": 'Hidden',
                "GetValueMethod": { fn: getSelectedBillingAddressId }
            }],
            Validate: false,
            RequestParam: 'billingAddressId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select billing address or create a new one.'
        }
    };

    function getSelectedBillingAddressId() {
        return defaultBillingAddress.id;
    };

    function baseInit(model) {
        viewModel = {
            addressType: addressType,
            enableInternationalBilling: model.enableInternationalBilling,
            countries: model.countries || {},
            states: model.states || {},
            addressList: model.addresses || {},
            address: {
                btns: {
                    btnUseThis: { cssClass: 'useThisBillingAddress', text: 'Use this address' },
                    btnSelected: { cssClass: 'selected', text: 'Selected address' }
                }
            },
            prefix: 'terms-'
        };
    }

    function initCheckout(model, billingAddress, paymentTypes) {
        baseInit(model);
        viewModel.forms = forms;
        defaultBillingAddress = billingAddress;
        var terms = _.find(paymentTypes, { name: 'My Terms' });
        if (terms && terms.customFields) {
            viewModel.yourTerms = terms.customFields.yourTerms;
        }
        return viewModel;
    }

    var Terms = {
        initCheckout: initCheckout,
        defaultBillingAddress: defaultBillingAddress,
        forms: forms
    };

    Roc.Logger.debug('Terms.js Loaded:', Terms);
    return Terms;

});
